import styled from 'styled-components';
import SnapToRoadSvg from '../../../assets/icons/snap-to-road.svg';
import GeofencesSvg from '../../../assets/icons/geofence.svg';
import TargetSvg from '../../../assets/icons/target.svg';
import InterPlate from '../../../assets/icons/interpolate.svg';
import RouteHistorySvg from '../../../assets/icons/path-marker.svg';

const Wrapper = styled.div`
  /* anchors the route history loading overlay */
  position: relative;

  .custom-map-button {
    width: 50px;
    height: 40px;
    color: rgb(25, 25, 25);
    /* padding: 5px; */
    margin: 10px 0 22px;
    padding: 0 5px;
    background-color: ${(props) => props.theme.colors.white};
    /* border: 2px solid ${(props) => props.theme.colors.white}; */
    border-radius: 3px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    font-family: Roboto, Arial, sans-serif;
    font-size: 16px;
    line-height: 38px;
    text-align: center;

    &.active {
      background-color: ${(props) => props.theme.colors.main_cta};
    }

    &.snap-to-road {
      background-image: url(${SnapToRoadSvg});
      background-repeat: no-repeat;
      background-position: center;
    }

     &.fake-points {
      background-image: url(${InterPlate});
      background-repeat: no-repeat;
      background-position: center;
      margin-left: 10px;
    }
    
    &.show-geofences {
      background-image: url(${GeofencesSvg});
      background-repeat: no-repeat;
      background-position: center;
      margin-left: 10px;
    }
    &.autofollow {
      background-image: url(${TargetSvg});
      background-repeat: no-repeat;
      background-position: center;
      margin-left: 10px;
    }
    &.route-history {
      background-image: url(${RouteHistorySvg});
      background-repeat: no-repeat;
      background-position: center;
      background-size: 20px 20px;
      margin-left: 10px;
    }
  }
`;

// Shown while the route history is being fetched. Deliberately click-through: the map
// stays usable, the overlay only says that the path on screen is not the final one yet.
const RouteHistoryLoader = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: rgba(19, 19, 19, 0.45);

  .loader-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    border-radius: 8px;
    background: ${(props) => props.theme.colors.widget_background};
    border: 1px solid ${(props) => props.theme.colors.outline};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    color: ${(props) => props.theme.colors.text};
    font-size: 13px;
    white-space: nowrap;
  }

  .spinner {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid ${(props) => props.theme.colors.outline};
    border-top-color: ${(props) => props.theme.colors.main_cta};
    animation: route-history-spin 0.8s linear infinite;
  }

  @keyframes route-history-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default { Wrapper, RouteHistoryLoader };
